import { REVISION, VERSION } from "../consts/version";

$(function () {
  $(window).on("load", function () {
    //Version set start
    $("#version-number").html(`v${VERSION} (${REVISION})`);
    //Version set end
  });

  $(".lazy").Lazy({
    scrollDirection: "vertical",
    effect: "fadeIn",
    visibleOnly: true,
    onError: function (element) {
      return;
    },
  });

  $(window).on("resize", function () {
    $(".section-banner").css("width", $(".section-contact .shell").width());

    if (
      $(window).outerWidth() > 1199 &&
      $("body").hasClass("has-menu-opened")
    ) {
      $("body").removeClass("has-menu-opened").removeClass("is-fixed");
    }
  });

  $(".js-search-btn").on("click", function () {
    if ($(window).outerWidth() <= 1199) {
      if ($("body").hasClass("has-menu-opened")) {
        $(".header-wrapper .header .header__nav").css("padding", "60px 25px");
      } else {
        if ($(".popup-search").hasClass("is-active")) {
          $(".header-wrapper .header .header__nav").css("padding", "60px 25px");
        } else {
          $(".header-wrapper .header .header__nav").css("padding", "31px 25px");
        }
      }
    }
  });
});
